import React from 'react';

import ArrowBtn from '../buttons/ArrowBtn';

function PageTitleSection({ haveArrow, children, executeScroll }) {
  return (
    <div className={`page-title-section d-flex flex-column flex-sm-row justify-content-start justify-content-sm-between mt-0 mt-sm-5 pt-0 pt-sm-5 fit-width career-title override`}>
      <div >
        {children}
      </div>
      {haveArrow && <ArrowBtn executeScroll={executeScroll} />}
    </div>
  );
}

export default PageTitleSection;